import { combineReducers } from 'redux';
import AuthReducer from './slices/auth.slice';
import CategoryReducer from './slices/category.slice';
import CartReducer from './slices/cart.slice';
import NewsReducer from './slices/news.slice';
import UserLocationReducer from './slices/userLocation.slice';
import checkoutReducer from './slices/checkout.slice';
import MobileMenuCartReducer from './slices/mobilemenucart.slice';
import MobileMenuLocationReducer from './slices/mobileMenuLocation.slice';

const rootReducer = combineReducers({
  auth: AuthReducer,
  category: CategoryReducer,
  cart: CartReducer,
  news: NewsReducer,
  userLocation: UserLocationReducer,
  checkout: checkoutReducer,
  mobileMenuCart: MobileMenuCartReducer,
  mobileMenuLocation: MobileMenuLocationReducer,
});

export default rootReducer;
